import { useState, useEffect } from "react";
import { getMonthlyTrackedObjects } from "../../../services/container";

export const useCampaignAnomalies = (campaignPeriod) => {
  const [monthlyTrackedObjects, setMonthlyTrackedObjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMonthlyTrackedObjects = async () => {
      if (!campaignPeriod || !campaignPeriod.start || !campaignPeriod.stop) {
        setMonthlyTrackedObjects([]);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const containerIds =
          campaignPeriod.containerObjectIdList &&
          campaignPeriod.containerObjectIdList.length > 0
            ? campaignPeriod.containerObjectIdList.join(",")
            : undefined;

        const response = await getMonthlyTrackedObjects({
          periodStart: campaignPeriod.start,
          periodStop: campaignPeriod.stop,
          containerIds: containerIds,
        });

        if (response.status === 200) {
          setMonthlyTrackedObjects(response.data.monthlyTrackedObjects || []);
        } else {
          setError("Failed to fetch monthly tracked objects");
          setMonthlyTrackedObjects([]);
        }
      } catch (err) {
        console.error("Error fetching monthly tracked objects:", err);
        setError(err.message);
        setMonthlyTrackedObjects([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMonthlyTrackedObjects();
  }, [campaignPeriod]);

  return {
    monthlyTrackedObjects,
    isLoading,
    error,
  };
};
